import React, { useState } from 'react';
import { Box, Image, Stack, Text } from '@chakra-ui/react';


function Carousel( { images, size, imgPreview = false, dots = true, banner='', arrowColor='grey' } ){

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImage, setCurrentImage] = useState(images[0]);
  const [loaded, setLoaded] = useState(false);
  const [hover, setHover] = useState(false);

  /*
    Selecciona la próxima o anterior imagen en display dentro de los límites del array de imágenes, dependiendo de la dirección indicada por parámetro.
  */
  function move(forward){
    let newIndex;
    if (forward){
      currentIndex === (images.length - 1) ? newIndex = currentIndex : newIndex = currentIndex + 1;
    } else{
      currentIndex === 0 ? newIndex = currentIndex : newIndex = currentIndex - 1;
    }
    goTo(newIndex);
  }

  /*
    Muestra la imagen deseada. No controla que el índice sea correcto, puesto que dicho control se encuentra en el objeto de UI
  */
  function goTo(index){
    // Evitamos animaciones indeseadas
    if (currentIndex !== index) {
      setLoaded(false);
      setTimeout( () => {
      setCurrentIndex(index);
      setCurrentImage(images[index]);
      }, 600);
    }
  }

  function rangeIndex(index){
    let indexInRange;
    index < 0 ? indexInRange = (images.length + index) : indexInRange = index % images.length;
    return indexInRange;
  }

  /*
    Renderiza la vista de navegación de imágenes por selección de índice simbolizado con puntos.
  */
  function renderDotsNavigationBar(){
    return(
      <Stack direction='row' justifyContent='center' alignItems='center'>
        {images.map((img, index) => (<Text  key={ index } onClick={ () => goTo(index) } fontSize={'2xl'} cursor={'pointer'}
                                            color={ currentIndex === index ? '#bde0fe' : 'grey' }
                                            _hover={{ transform: 'scale(1.3);'}}
                                            transitionDuration={'0.2s'}> • </Text>) )}
      </Stack>
    );
  }

  /*
    Renderiza la vista de navegación de imágenes con previews en tamaño reducido
  */
  function renderImagesPreview(){
    return (
      // Êsto está sucio por ahora
      <Stack direction='row' spacing='10%' justifyContent='center' w='70%' display={['none, block']}>
        <Image src={images.at(currentIndex - 1)} onClick={() => goTo(rangeIndex(currentIndex - 1))} boxSize={'25%'} cursor='pointer' ></Image>
        <Image src={images[currentIndex]} boxSize={'25%'} border='1px orange solid' cursor='pointer' ></Image>
        <Image src={images.at((currentIndex + 1) % images.length)} onClick={() => goTo(rangeIndex(currentIndex + 1))} boxSize={'25%'} cursor='pointer' ></Image> 
      </Stack>
    );
  }

  function renderDescription() {
    return(
      <Box  w={`${size}px`} h={'25%'} position='absolute' top='75%' right='0%' zIndex='4'
              color='black' opacity={ hover ? '0.7' : '0' } transition='0.7s' bgGradient='linear-gradient(0deg, rgba(51,51,51,1) 0%, rgba(204,204,204,1) 100%)'>
          <Text p='4%'> Nombre Proyecto</Text>
      </Box>
    );
  }


  return(
    <Stack direction='column' w={['80vw',`${size}px`]} h={['30vh',`${size * 0.75}px`]} alignItems='center' justifyContent='center'>
      
      <Stack direction='row' spacing='3%' alignItems={'center'} my='1%' overflow={'hidden'} onMouseEnter={ () => setHover(true) } onMouseLeave={ () => setHover(false) } position='relative'>
        {/*  Carga 'lazy' */}
        <Image src={require(`./${currentImage}`)} id='current' className={loaded ? "loaded" : ""}
               transition='1s' bgSize='cover' zIndex='1' opacity={ loaded ? 1 : 0}
               onLoad={() => setLoaded(true) }>
        </Image>
        <Text fontSize='5xl'color='grey' zIndex='2' position='relative' right='101%' 
              onClick={ () => {move(false)} } cursor={'pointer'}
              opacity={currentIndex > 0 ? '1' : '0'}
              _hover={{ transform: 'scale(1.3);'}}
              transitionDuration={'0.2s'}>{'<'}</Text>
        <Text fontSize='5xl'color='grey' zIndex='2' position='relative' right={['28%','20%']} 
              onClick={ () => {move(true)} } cursor={'pointer'}
              opacity={currentIndex < (images.length - 1) ? '1' : '0'}
              _hover={{ transform: 'scale(1.3);'}}
              transitionDuration={'0.2s'}>{'>'}</Text>
        { banner ? renderDescription() : null }
        
      </Stack>

      { imgPreview ? renderImagesPreview() : dots ? renderDotsNavigationBar() : null}

    </Stack>
  );
}


export default Carousel;